import { render, staticRenderFns } from "./pop_special_price_list.vue?vue&type=template&id=01173428"
import script from "./pop_special_price_list.vue?vue&type=script&lang=js"
export * from "./pop_special_price_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports